export interface SearchCriteria {
  columnId: number;
  filterValues: string;
  priority?: number;
}

export interface ClickedCount {
  buHierarchyId: number;
  rowHierarchyId: number;
  clickedColumnId: number;
}

export interface SortCriteria {
  columnId?: number;
  isAscending?: boolean;
}

export interface FilterList {
  name: string;
  isSelected: boolean;
}

export interface ColumnFilters {
  list: string[];
  columnId: number;
  filterData: SearchCriteria[];
}

export interface FilterTag {
  name: string;
  columnId: number;
}

import { ConfigurableFocusTrapFactory } from "@angular/cdk/a11y";
import {
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  HostListener,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatCheckbox } from "@angular/material/checkbox";
import { distinctUntilChanged } from "rxjs/operators";
import { DataSharingService } from "src/app/services/data-sharing.service";
// import { FilterList } from "../../models/filter-list";
import * as moment from "moment";

@Component({
    selector: "app-table-filter-on-column",
    templateUrl: "./table-filter-on-column.component.html",
    styleUrls: ["./table-filter-on-column.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableFilterOnColumnComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @ViewChild("selectAll") selectAll: MatCheckbox;
  @ViewChild("tableFilterServer") tableFilter: ElementRef;
  @Input() objPosition: any;
  @Input() columnId: any;

  @Output() filterData = new EventEmitter();
  @Output() closeFilterOverlay = new EventEmitter();

  elm: HTMLElement;
  queryField: UntypedFormControl = new UntypedFormControl();

  selectedDateType: string;
  calType: string[] = [
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "Custom date",
    "Custom range",
  ];
  optionList: FilterList[] = [];
  backupOptionList: FilterList[] = [];
  isSelectedAll = false;
  maxDate = new Date();
  selectedDate: any;
  dateRangeStart: any;
  dateRangeEnd: any;

  constructor(
    private el: ElementRef,
    private dataSharingService: DataSharingService,
    private focusTrap: ConfigurableFocusTrapFactory
  ) {}

  @HostListener("window:keyup", ["$event"])
  keyFunc(event) {
    if (event.code === "Escape") this.closeFilter();
  }

  ngOnChanges() {}

  ngAfterViewInit(): void {
    document.body.appendChild(this.el.nativeElement);
    this.setFocusTrap();
  }

  ngOnInit(): void {
    this.searchData();
    this.dataSharingService.filtersWithCheckedValues$.subscribe((list) => {
      this.optionList = [...list];
      this.backupOptionList = [...list];
    });
  }

  changeComboo(event) {
    console.log("chnaged", event && event.value);
  }

  searchData() {
    this.queryField.valueChanges
      .pipe(
        // debounceTime(100),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        if (result) {
          this.optionList = this.backupOptionList.filter((filter) =>
            filter.name?.toLowerCase().includes(result.toLowerCase())
          );
        } else {
          this.optionList = [...this.backupOptionList];
        }
        this.selectAll.writeValue(this.isAllSelected());
      });
  }

  closeFilter() {
    this.closeFilterOverlay.emit("");
  }

  selectDeselectAll(e) {
    if (e.checked) {
      // this.isSelectedAll = true;
      this.optionList.forEach((options) => {
        options.isSelected = true;
      });
    } else {
      // this.isSelectedAll = false;
      this.optionList.forEach((options) => {
        options.isSelected = false;
      });
    }
  }

  isAllSelected() {
    return this.optionList.every((x) => x.isSelected === true);
  }

  setValue(e, i) {
    if (i > -1) {
      this.optionList[i].isSelected = e.checked;
      this.optionList = [...this.optionList];
    }
    this.selectAll.writeValue(this.isAllSelected());
  }

  searchApply() {
    let filterValues = "";
    if (this.columnId.filterOn != 8) {
      const filterValueList = this.optionList
        .filter((option) => option.isSelected)
        .map((value) => value.name);
      if (filterValueList) filterValues = filterValueList.join(",");
    } else {
      filterValues = this.dateFilter();
    }
    this.filterData.emit(filterValues);
  }

  dateFilter() {
    const date =  moment.utc().valueOf();
    const utcDay= moment.utc(moment.default().format("L")).valueOf()
    switch (this.selectedDateType) {
      case "Yesterday": {
    const utcDay= moment.utc(moment.default().format("L")).valueOf()
        return `${utcDay - 1000 * 3600 * 24 * 1}, ${utcDay}, ${this.selectedDateType}`;
        break;
      }
      case "Last 7 Days": {
        return `${date - 1000 * 3600 * 24 * 7}, ${date}, ${this.selectedDateType}`;
        break;
      }
      case "Last 30 Days": {
        return `${date - 1000 * 3600 * 24 * 30}, ${date},${this.selectedDateType}`;
        break;
      }
      case "Custom date": {
        return `${this.selectedDate.getTime()}, ${
          this.selectedDate.getTime() + 1000 * 3600 * 24 * 1
        }, ${this.selectedDateType}`;
        break;
      }
      case "Custom range": {
        return `${this.dateRangeStart.getTime()}, ${
          this.dateRangeEnd.getTime() + 1000 * 3600 * 24 * 1
        }, ${this.selectedDateType}`;
        break;
      }

      default: {
        console.log("a+b is 5.");
        break;
      }
    }
  }
  ngOnDestroy(): void {
    this.el.nativeElement.remove();
    const filterBtn = document.getElementById("filter-btn");
    filterBtn.focus();
  }

  setFocusTrap() {
    const focusTrap = this.focusTrap.create(this.tableFilter.nativeElement);
    focusTrap.focusInitialElement();
  }

  onSelect(event) {
    this.selectedDate = event;
  }

  inlineRangeChange(event) {
    this.dateRangeStart = event.begin;
    this.dateRangeEnd = event.end;
  }
}
